import Vue from 'vue'
import {
	udeskUrl,
	loginUrl,
	hasPermission
} from './common.js'
Vue.prototype.$UdeskUrl = udeskUrl

Vue.prototype.$LoginUrl = loginUrl

Vue.prototype.$HasPermission = hasPermission
